// Generated by scripts/write-memory-feast-replay-fixtures.ts.
// Do not edit manually.

import type { MemoryFeastReplayEventType } from "./event-adapter";

export interface MemoryFeastReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface MemoryFeastReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: MemoryFeastReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface MemoryFeastReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "memory-feast";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly MemoryFeastReplayFixturePlayer[];
  readonly events: readonly MemoryFeastReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const MEMORY_FEAST_REPLAY_FIXTURES: Record<
  string,
  MemoryFeastReplayFixture
> = {
  "heuristic-2p": {
    schemaVersion: 1,
    gameType: "memory-feast",
    scenario: "heuristic-2p",
    source: "generated",
    capturedAt: "2026-06-18T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "선 (휴리스틱)",
        role: "host",
      },
      {
        id: "p2",
        name: "후 (휴리스틱)",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "heuristic-2p",
            players: [
              {
                playerId: "p1",
                label: "선",
              },
              {
                playerId: "p2",
                label: "후",
              },
            ],
            phase: "place",
            bowls: [
              {
                id: 0,
                count: 0,
                open: false,
              },
              {
                id: 1,
                count: 0,
                open: false,
              },
              {
                id: 2,
                count: 0,
                open: false,
              },
              {
                id: 3,
                count: 0,
                open: false,
              },
              {
                id: 4,
                count: 0,
                open: false,
              },
              {
                id: 5,
                count: 0,
                open: false,
              },
              {
                id: 6,
                count: 0,
                open: false,
              },
              {
                id: 7,
                count: 0,
                open: false,
              },
              {
                id: 8,
                count: 0,
                open: false,
              },
              {
                id: 9,
                count: 0,
                open: false,
              },
              {
                id: 10,
                count: 0,
                open: false,
              },
              {
                id: 11,
                count: 0,
                open: false,
              },
              {
                id: 12,
                count: 0,
                open: false,
              },
              {
                id: 13,
                count: 0,
                open: false,
              },
              {
                id: 14,
                count: 0,
                open: false,
              },
              {
                id: 15,
                count: 0,
                open: false,
              },
              {
                id: 16,
                count: 0,
                open: false,
              },
              {
                id: 17,
                count: 0,
                open: false,
              },
              {
                id: 18,
                count: 0,
                open: false,
              },
              {
                id: 19,
                count: 0,
                open: false,
              },
            ],
            round: 1,
            firstPlayerId: "p1",
            currentPlayerId: "p1",
            moveNumber: 0,
            lastOpen: null,
            winnerId: null,
            lastAction: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0],
          moveNumber: 0,
        },
      },
      {
        sequenceNumber: 3,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0],
          moveNumber: 1,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1],
          moveNumber: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1],
          moveNumber: 3,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2],
          moveNumber: 4,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2],
          moveNumber: 5,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3],
          moveNumber: 6,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3],
          moveNumber: 7,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3, 4],
          moveNumber: 8,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3, 4],
          moveNumber: 9,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3, 4, 5],
          moveNumber: 10,
        },
      },
      {
        sequenceNumber: 13,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3, 4, 5],
          moveNumber: 11,
        },
      },
      {
        sequenceNumber: 14,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3, 4, 5, 6],
          moveNumber: 12,
        },
      },
      {
        sequenceNumber: 15,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3, 4, 5, 6],
          moveNumber: 13,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3, 4, 5, 6, 7],
          moveNumber: 14,
        },
      },
      {
        sequenceNumber: 17,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3, 4, 5, 6, 7],
          moveNumber: 15,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3, 4, 5, 6, 7, 8],
          moveNumber: 16,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3, 4, 5, 6, 7, 8],
          moveNumber: 17,
        },
      },
      {
        sequenceNumber: 20,
        eventType: "PlaceTokens",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          moveNumber: 18,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "PlaceTokens",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          moveNumber: 19,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "OpenBowls",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [0, 1],
          moveNumber: 20,
        },
      },
      {
        sequenceNumber: 23,
        eventType: "OpenBowls",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [2, 3],
          moveNumber: 21,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "OpenBowls",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [4, 5],
          moveNumber: 22,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "OpenBowls",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [6, 7],
          moveNumber: 23,
        },
      },
      {
        sequenceNumber: 26,
        eventType: "OpenBowls",
        userId: "p1",
        payload: {
          playerId: "p1",
          bowlIds: [8, 9],
          moveNumber: 24,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "OpenBowls",
        userId: "p2",
        payload: {
          playerId: "p2",
          bowlIds: [10, 11],
          moveNumber: 25,
        },
      },
    ],
    notes: [
      "기억의 만찬은 숨김정보 게임 — 그릇 합계는 서버 권위. 리플레이 픽스처는 복기용 권위 데이터를 담고, 화면은 덮인 그릇을 마스킹(가이드 준수)한다.",
      "공정 휴리스틱(no-oracle): 봇은 마스킹된 뷰 + 공개된 오픈 reveal만 사용. 배치=그라디언트(라운드 N→그릇 0..N-1), 오픈=최저 미공개 2그릇 probe, 공개된 동수쌍이 생기면 오픈→승리.",
      "결과: 배치 20수 + 오픈 6수 → 후(p2) 승리.",
    ],
  },
};
